import React from 'react'

const defaultValue = {
  locale: 'en',
  userLoggedIn: false,
  currentUserIsAdmin: false,
  cgdreamOrigin: false,
  pageConfigLoaded: false,
  extractingCoreStyles: false,
  dccSoftwares: [],
  showGenerationErrorDetails: false,
  modelFeedbackEnabled: false,
  enableHunyuanSegmentation: false,
  enableMeshyRemesh: false,
  enableAnimation: false,
  treeViewEnabled: false,
  unfinishedTwoDFeaturesEnabled: false,
  imageGenerationWithStylesEnabled: false,
  imageSearchOnIdeationFLowEnabled: false,
}

const ThreeDStudioPageContext = React.createContext(defaultValue)

export default ThreeDStudioPageContext
